import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import context from "../../store/context";

import useInput from "../../hooks/use-Input";

import AuthenticationButton from "../Buttons/AuthenticationButton";
import FieldRow, { rowInputClass } from "../UI/FieldRow";

//icons
import CheckIcon from "../icons/Check";

const PersonalInfo = ({ onSuccess }) => {
  const {
    userInfo,
    setUserInfo,
    isVerified,
    setIsVerified,
    VerifyContact,
  } = useContext(context);
  const [emailTaken, setEmailTaken] = useState(false);
  const [EmailErrorMessage, setEmailErrorMessage] = useState("");

  const fullNameValidator = (enteredValue) => {
    return enteredValue.trim().length > 2;
  };

  const {
    enteredValue: fullNameValue,
    hasError: fullNameHasError,
    valueChangeHandler: fullNameValueChangeHandler,
    inputBlurHandler: fullNameInputBlurHandler,
    isValid: fullNameIsValid,
    reset: fullNameReset,
  } = useInput(fullNameValidator, userInfo.name);

  const emailValidator = (enteredValue) => {
    // Regular expression for email or phone number validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emailRegex.test(enteredValue);
  };
  const {
    enteredValue: emailValue,
    valueChangeHandler: emailValueChangeHandler,
    inputBlurHandler: emailInputBlurHandler,
    isValid: emailIsValid,
    reset: emailReset,
  } = useInput(emailValidator, userInfo.email);

  useEffect(() => {
    fullNameReset();
    emailReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  const userToken = sessionStorage.getItem("token");

  const [isUpdating, setIsUpdating] = useState(false);

  const updatePersonalInfo = () => {
    setEmailTaken(false);

    if (fullNameIsValid && emailIsValid) {
      setIsUpdating(true);
      setEmailTaken(false);

      var headers = new Headers();
      headers.append("X-XSRF-TOKEN", "csrf-cookie");
      headers.append("Accept", "application/json");
      headers.append("Authorization", `Bearer ${userToken}`);

      var requestOptions = {
        method: "POST",
        headers: headers,
        redirect: "follow",
      };

      fetch(
        `https://api.ichereta.com/api/client/account/personal?name=${fullNameValue}&email=${emailValue}&phone=${userInfo.phone}`,
        requestOptions
      )
        .then((response) => {
          if (response.status === 401) {
            sessionStorage.clear();
            window.location.href = "/";
          }
          return response.json();
        })
        .then((result) => {
          setIsUpdating(false);

          console.log(result);
          if (result.status) {
            onSuccess(true);
            setTimeout(() => {
              onSuccess(false);
            }, 2000);

            if (userInfo.email !== emailValue) {
              setIsVerified({ ...isVerified, email: false });
            }

            setUserInfo({
              ...userInfo,
              name: result.user.name,
              email: result.user.email,
              phone: result.user.client_info.phone,
              address: result.user.client_info.address,
              companyName: result.user.client_info.company_name,
              tin: result.user.client_info.TIN,
            });
          } else {
            if (result.errors.email) {
              setEmailErrorMessage(result.errors.email);
              setEmailTaken(true);
            }
          }
        })
        .catch((error) => {
          setIsUpdating(false);
          console.log("error", error);
        });
    }

    if (!emailIsValid) {
      setEmailErrorMessage("Not a valid email.");
      setEmailTaken(true);
    } else {
      setEmailTaken(false);
    }
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-[0_2px_10px_rgba(61,89,132,0.06)]">
        <FieldRow
          label="Full Name"
          error={fullNameHasError ? "Enter at least 3 characters." : ""}
        >
          <input
            id="personalInfoName"
            type="text"
            placeholder="Your name"
            value={fullNameValue}
            onChange={fullNameValueChangeHandler}
            onBlur={fullNameInputBlurHandler}
            className={rowInputClass}
          />
        </FieldRow>
        <FieldRow
          label="Email"
          last
          error={emailTaken ? EmailErrorMessage : ""}
        >
          <input
            id="personalInfoEmail"
            type="email"
            placeholder="you@email.com"
            value={emailValue}
            onChange={emailValueChangeHandler}
            onBlur={emailInputBlurHandler}
            className={rowInputClass}
          />
          {isVerified.email ? (
            <span className="flex items-center gap-1 text-xs font-medium bg-green-500/10 text-green-700 pl-1.5 pr-2.5 rounded-full py-0.5 shrink-0">
              <CheckIcon styles="w-3.5 h-3.5" />
              Verified
            </span>
          ) : (
            <Link
              to="/verification/email"
              onClick={() => {
                VerifyContact(`email=${userInfo.email}&for=email`);
              }}
              className="text-xs font-semibold text-[#664bc7] shrink-0"
            >
              Verify
            </Link>
          )}
        </FieldRow>
      </div>
      <AuthenticationButton
        process={isUpdating}
        onClick={updatePersonalInfo}
        className="w-full h-12 bg-[#664bc7] hover:bg-[#664bc7]/90 text-white rounded-xl font-semibold transition-colors relative overflow-hidden"
        name="Save Changes"
      />
    </div>
  );
};

export default PersonalInfo;
